export function BottomSwoop() {
  return (
    <svg
      viewBox="0 0 1430 140"
      style={{
        position: "relative",
        width: "100%",
        top: -5,
        zIndex: 0,
      }}
      className="top-swoop"
      fill="#FFF"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1440 0v59.969c-65.287-39.594-188.865-55.343-370.736-47.248C766 26.221 627.87 140 277 140 171.698 140 79.365 124.417 0 93.25V0h1440z" />
    </svg>
  );
}
